import { render, staticRenderFns } from "./ChatBoxTracking.vue?vue&type=template&id=0480f8df&scoped=true"
import script from "./ChatBoxTracking.vue?vue&type=script&lang=js"
export * from "./ChatBoxTracking.vue?vue&type=script&lang=js"
import style0 from "./ChatBoxTracking.vue?vue&type=style&index=0&id=0480f8df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480f8df",
  null
  
)

export default component.exports